import type { LoaderElementProps } from './LoaderElement.types';

export function LoaderElement({ count = 4, className = '' }: LoaderElementProps) {
  return (
    <div className={`flex flex-col gap-y-2 ${className}`}>
      {Array.from({ length: count }).map((_, idx) => (
        <div key={idx} className="h-8 w-full rounded bg-gray-100/80" />
      ))}
    </div>
  );
}
